import { LAB_EMP_EMPLOYEES_ITEM } from './lab-emp-employees.js'

/** @type {import('../help-index.js').HelpScreen} */
export const LAB_EMP_HELP = {
  screenId: 'lab-emp',
  label: 'Empleados',
  navPath: 'Laboral → Empleados',
  keywords: [
    'empleado', 'legajo', 'cuil', 'cuit', 'obra social', 'liquidación', 'sueldo', 'arca', 'afip',
  ].map((k) => k.toLowerCase()),
  status: 'draft',
  summary:
    'Legajos de trabajadores: datos personales, contacto, CBU, categoría, datos previsionales LSD/F.931 y conceptos por empleado.',
  sidebarItems: [LAB_EMP_EMPLOYEES_ITEM],
}
